<template>
  <div class="countdown">
    <div class="countdowndetail" v-if="count_down.detail.enabled&& position=='detail'&&onOff" :class="theme=='venue'?'venue':''">
      <h3 class="page_text_font">{{count_down.detail.text}}</h3>
      <div
        class="timer page_text_font"
      >{{(hour.toString().padStart(2,'0'))+':'+(minute.toString().padStart(2,'0'))+':'+(second.toString().padStart(4,'0'))}}</div>
    </div>
    <div class="countdowncheckout" v-if="count_down.checkout.enabled&&position=='checkout'">
      <div  v-if="timeout>0">
        <span class="iconfont icon-zhong"></span>
        {{$t('shopping.Your_order_is_reserved_for')}}
        <span
          class="count-down-time"
        >{{(minute.toString().padStart(2,'0'))+':'+( Math.floor(second).toString().padStart(2,'0'))}}</span> {{$t('shopping.minutes')}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["count_down", "position", "no_reset", "theme"],
  data() {
    return {
      timeout: "",
      future_time: "",
      now_time: "",
      hour: "00",
      minute: "00",
      second: "00",
      set_timer: 0,
      time_base: "",
      onOff: true,
    };
  },

  methods: {
    is_repeat() {
      this.future_time = new Date().getTime() + this.set_timer * this.time_base;
      localStorage.setItem(this.position + "_timeout", this.future_time);
      localStorage.setItem(
        this.position + "_timeout_num",
        this.time_base * this.set_timer
      );
      // if (
      //   this.count_down.detail.time_type == "hour" &&
      //   this.position == "detail"
      // ) {
      //   this.timeout = this.set_timer * 60 * 60 * 1000;
      // } else {
      //   this.timeout = this.set_timer * 60 * 1000;
      // }
    },
    time_cut() {
      this.now_time = new Date().getTime();
      this.timeout = this.future_time - this.now_time - 100;
      if (this.timeout < 0) {
        if (this.position == "detail" && this.count_down.detail.is_repeat) {
          this.is_repeat();
        } else {
          clearInterval(this.setInterval);
          this.onOff = false;
        }
        if (this.position == "checkout") {
          clearInterval(this.setInterval);
          localStorage.removeItem("checkout_timeout");
        }
      }
      this.hour = Math.floor(this.timeout / 3600000);
      this.minute = Math.floor((this.timeout - this.hour * 3600000) / 60000);
      this.second = (
        (this.timeout - this.hour * 3600000 - this.minute * 60000) /
        1000
      ).toFixed(1);
    },
  },
  beforeMount() {
    // 判断是否在结账页，且是否是页面刷新
    let isRefresh
    if (window.performance.navigation.type == 1 || document.referrer.includes('checkouts')) {
        isRefresh=true
    }else{
        isRefresh=false
    }
    if(this.getSearch('utm_medium') == 'email'){
      isRefresh= true 
    }
    this.time_base =
      this.count_down.detail.time_type == "hour" && this.position == "detail"
        ? 3600000
        : 60000;
    this.set_timer =
      this.position == "detail"
        ? this.count_down.detail.total_time
        : this.count_down.checkout.total_time;
    this.future_time = localStorage.getItem(this.position + "_timeout");
    this.future_time_num = localStorage.getItem(this.position + "_timeout_num");
    this.set_timer =
      this.set_timer > 0 ? this.set_timer : Math.abs(this.set_timer);
      
    // 后台修改倒计时时间 ，刷新页面或者从购物车页重新进入页面，结账页倒计时重新计算
    const timeIsChange =this.future_time_num != this.time_base * this.set_timer;
    
    if (
      !this.future_time_num ||
      this.future_time_num != this.time_base * this.set_timer ||
      (!this.future_time && !this.no_reset)
    ) {
      if (this.count_down.checkout.enabled && this.position == "checkout"&&(!isRefresh || timeIsChange )) {
        this.is_repeat();
      }
      if (this.count_down.detail.enabled && this.position == "detail") {
        this.is_repeat();
      }
    }
    this.time_cut();
    this.setInterval = setInterval(() => {
      this.time_cut();
    }, 100);
  },
};
</script>

<style scoped lang='scss'>
.countdown {
  .countdowndetail {
    background-image: url("~@/images/timeout.jpg");
    width: 100%;
    height: 40px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;
    color: #fe2121;
    h3 {
      align-items: center;
      padding: 0;
      margin: 0;
      font-size: 14px;
      line-height: 18px;
      width: auto;
      text-align: left;
      color: #fff;
    }
    .timer {
      min-width: 120px;
      height: 26px;
      background: #fff;

      border-radius: 15px;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .countdowncheckout {
    color: #fe2121;
    display: block;
    font-size: 14px;
    margin: 20px 0;
    text-align: center;
    font-weight: bold;
    .count-down-time {
      color: #fff;
      height: 24px;
      margin: 0 2px;
      padding: 0 8px;
      font-weight: 600;
      line-height: 26px;
      border-radius: 4px;
      display: inline-block;
      position: relative;
      top: -2px;
      background: linear-gradient(to bottom, #ef5220, #fe2121);
    }
  }
}
@media screen and (max-width: 575px) {
  .countdown {
    padding: 0 !important;
    .countdowndetail {
      // margin: 0 -15px !important;
      width: 100%;
    }
    .venue{
      margin: 0 !important;
      width: 100%;
    }
  }
}
</style>